import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { RepairCodeSearchTextForm } from '../../../form-model/repair-code-search-text.form.model';

@Component({
    selector: 'app-repair-code-search',
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
    templateUrl: './repair-code-search.component.html',
    styleUrl: './repair-code-search.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RepairCodeSearchComponent implements OnInit {
    @Input({ required: true }) repairCodeSearchTextForm!: FormGroup<RepairCodeSearchTextForm>;

    constructor(private readonly formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.addControlsToTheFormGroup();
    }

    applySearchTextFilters(): void {
        this.repairCodeSearchTextForm.controls.appliedRepairCodeSearchTextFilter.setValue(true);
    }

    isControlInErrorState(control: FormControl): boolean | null {
        if (control.invalid && control.touched) {
            return true;
        }
        return null;
    }

    private addControlsToTheFormGroup(): void {
        if (!this.repairCodeSearchTextForm.get('SearchText')) {
            this.repairCodeSearchTextForm.addControl('SearchText', this.formBuilder.control<string | null>(null));
        }
        if (!this.repairCodeSearchTextForm.get('appliedRepairCodeSearchTextFilter')) {
            this.repairCodeSearchTextForm.addControl('appliedRepairCodeSearchTextFilter', this.formBuilder.control<boolean | null>(null));
        }
    }
}
